module.exports = __webpack_public_path__ + "img/walletIcon.48a6d744.png";